import {Skeleton} from "@mui/material";
import React from "react";

export const ButtonSuspense = ({w = 160}: { w?: number }) => {
    return <Skeleton variant="rectangular" width={w} height="40px"/>;
}

export const ButtonIconSuspense = () => {
    return <Skeleton variant="circular" width="25px" height="25px"/>;
}
